"use client";

import { useTranslations } from "next-intl";

const SERVICES = [
	{
		key: "shipping",
		icon: (
			<svg viewBox="0 0 40 40" fill="none" className="h-9 w-9" aria-hidden>
				<circle cx="20" cy="20" r="18" stroke="currentColor" strokeWidth="1.2" />
				<path d="M12 24h10V16H12z" stroke="currentColor" strokeWidth="1.2" strokeLinejoin="round" />
				<path d="M22 19h3l2.5 3V24H22" stroke="currentColor" strokeWidth="1.2" strokeLinejoin="round" />
				<circle cx="15.5" cy="25.5" r="1.8" stroke="currentColor" strokeWidth="1" />
				<circle cx="25" cy="25.5" r="1.8" stroke="currentColor" strokeWidth="1" />
			</svg>
		),
	},
	{
		key: "trend",
		icon: (
			<svg viewBox="0 0 40 40" fill="none" className="h-9 w-9" aria-hidden>
				<rect x="8" y="10" width="24" height="20" rx="2" stroke="currentColor" strokeWidth="1.2" />
				<path
					d="M12 22l4-4 3 3 9-9"
					stroke="currentColor"
					strokeWidth="1.3"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<text x="11" y="28" fontSize="7" fill="currentColor" fontFamily="sans-serif" fontWeight="600">
					Week
				</text>
			</svg>
		),
	},
	{
		key: "factory",
		icon: (
			<svg viewBox="0 0 40 40" fill="none" className="h-9 w-9" aria-hidden>
				<path
					d="M8 30V18l6-4v4l6-4v4l6-4v16H8z"
					stroke="currentColor"
					strokeWidth="1.2"
					strokeLinejoin="round"
				/>
				<rect x="12" y="22" width="4" height="8" rx="0.5" stroke="currentColor" strokeWidth="1" />
				<rect x="20" y="22" width="4" height="8" rx="0.5" stroke="currentColor" strokeWidth="1" />
			</svg>
		),
	},
	{
		key: "manager",
		icon: (
			<svg viewBox="0 0 40 40" fill="none" className="h-9 w-9" aria-hidden>
				<circle cx="20" cy="15" r="5" stroke="currentColor" strokeWidth="1.2" />
				<path
					d="M10 32c0-5.5 4.5-10 10-10s10 4.5 10 10"
					stroke="currentColor"
					strokeWidth="1.2"
					strokeLinecap="round"
				/>
				<path
					d="M28 12l3-3m0 0v3m0-3h-3"
					stroke="currentColor"
					strokeWidth="1"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</svg>
		),
	},
];

export default function ServiceBar() {
	const t = useTranslations("homeBeauty");

	return (
		<section className="border-brand-ink/12 w-full border-t bg-white py-5 md:py-6">
			<div className="mx-auto w-full max-w-[1580px] px-5 sm:px-8 lg:px-12">
				<div className="grid grid-cols-2 gap-4 sm:grid-cols-4 sm:gap-0 sm:divide-x sm:divide-brand-ink/10">
					{SERVICES.map((svc) => (
						<div key={svc.key} className="flex items-start gap-3 px-2 py-1 sm:px-5">
							<div className="shrink-0 text-brand-ink/60">{svc.icon}</div>
							<div className="min-w-0">
								<h3 className="font-body text-[15px] font-bold leading-tight text-brand-ink">
									{t(`svc_${svc.key}_title`)}
								</h3>
								<p className="mt-1 font-body text-[13px] leading-[1.48] text-brand-ink/55">
									{t(`svc_${svc.key}_desc`)}
								</p>
							</div>
						</div>
					))}
				</div>
			</div>
		</section>
	);
}
